import { createContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import ReverseWithdrawalsList from "./Component/Vendor/ReverseWithdrawalsList";
import VendorDetail from "./Component/Vendor/VendorDetail";
import VendorForm from "./Component/Vendor/VendorForm";
import VendorSettings from "./Component/Vendor/VendorSettings";
import VendorsList from "./Component/Vendor/VendorsList";
import WithdrawalsList from "./Component/Vendor/WithdrawalsList";
import { LastRouteProvider } from "./controllers/LastRouteContext";
import { UserProvider, UserContext } from "./controllers/UserContext";
import { TableColumnsContext } from "./controllers/TableColumnsContext";
import API from "./API/newIndex";

export { UserContext, TableColumnsContext };
export const ChangePathContext = createContext();
export const PlanPermission = createContext();
export const DataLoad = createContext();
export const Extention = createContext();
export const StoreDeletePending = createContext();

const App = () => {
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [installedExtensions, setInstalledExtensions] = useState([]);
  const [tokenReady, setTokenReady] = useState(!!localStorage.getItem("token"));
  const [tableColumnsData, setTableColumnsData] = useState(null);
  const navigate = useNavigate();
  const [saveChanges, setSaveChanges] = useState({
    isUnsaveChanges: false,
    showChangesPopup: false,
    backLink: "",
    title: "",
  });
  const [planPermission, setPlanPermission] = useState({
    isPlanPermissions: true,
    forModule: null,
  });
  const [dataLoading, setDataLoading] = useState(false);
  const installExtentionName =
    installedExtensions?.length > 0 ? installedExtensions?.map((x) => x?.super_extension_id) : [];

  const GetInstalledExtensions = async () => {
    try {
      const ApiCall = await API({
        url: `/admin/extension/GetInstalledExtensions`,
        method: "get",
      });
      if (ApiCall.data) {
        const result = ApiCall?.data;
        setInstalledExtensions(result?.data);
        return result?.data;
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const getTableColumns = async () => {
    try {
      const res = await API({
        url: "/admin/product/getTableColumns",
        method: "get",
      });
      const data = res?.data?.data || res?.data || {};
      if (data?.tables) {
        setTableColumnsData(data.tables);
      } else if (data?.tableData) {
        setTableColumnsData(data.tableData);
      } else {
        setTableColumnsData(data);
      }
    } catch (error) {
      console.error("Failed to get table columns:", error);
    }
  };

  useEffect(() => {
    if (!tokenReady) return;
    GetInstalledExtensions();
    getTableColumns();
  }, [tokenReady]);

  useEffect(() => {
    const updateDarkModeClasses = (isDark) => {
      if (isDark) {
        document.documentElement.classList.add("dark-mode", "dark");
      } else {
        document.documentElement.classList.remove("dark-mode", "dark");
      }
    };

    // Apply dark mode theme if configured
    const savedDarkMode = localStorage.getItem("dark-mode");
    updateDarkModeClasses(savedDarkMode === "true" || savedDarkMode === true);

    const handleMessage = (event) => {
      const data = event.data;
      if (!data) return;

      // Handle INIT_IFRAME or message payload containing iframe data from parent
      if (data?.type === "INIT_IFRAME" || data?.token) {
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key) && key !== "type") {
            if (data[key] !== undefined && data[key] !== null) {
              localStorage.setItem(key, typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key]);
            }
          }
        }
        if (data.token) {
          setTokenReady(true);
        }
      }

      const targetPath = data?.path || data?.url;
      if (
        (data?.type === "NAVIGATE_IFRAME_INTERNAL" || data?.action === "navigateToHome") &&
        typeof targetPath === "string"
      ) {
        if (
          targetPath.startsWith("/vendors") ||
          targetPath.startsWith("/vendors/") ||
          targetPath.startsWith("/vendors/add")
        ) {
          navigate(targetPath);
        }
      }
      if (data?.type === "DARK_MODE_CHANGE" || data?.type === "INIT_IFRAME") {
        const isDarkMode =
          data?.type === "DARK_MODE_CHANGE"
            ? data["dark-mode"] === "true" || data["dark-mode"] === true
            : data["dark-mode"] === "true" || data["dark-mode"] === true;
        localStorage.setItem("dark-mode", isDarkMode);
        updateDarkModeClasses(isDarkMode);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [navigate]);

  return (
    <LastRouteProvider>
      <UserProvider tokenReady={tokenReady}>
        <TableColumnsContext.Provider value={{ tableColumnsData, setTableColumnsData, getTableColumns }}>
          <ChangePathContext.Provider value={{ saveChanges, setSaveChanges }}>
            <PlanPermission.Provider value={{ planPermission, setPlanPermission }}>
              <DataLoad.Provider value={{ dataLoading, setDataLoading }}>
                <Routes>
                  {installExtentionName?.length > 0 && installExtentionName?.includes("6683ed80529fd09fc74be6c7") && (
                    <>
                      <Route path="/vendors" element={<VendorsList />} />
                      <Route path="/vendors/detail/:id" element={<VendorDetail />} />
                      <Route path="/vendors/:id" element={<VendorForm />} />
                      <Route path="/vendors/add" element={<VendorForm />} />
                      <Route path="/vendors/settings" element={<VendorSettings />} />
                      <Route path="/vendors/withdraws" element={<WithdrawalsList />} />
                      {/* <Route path="/vendor/reverse-withdrawals" element={<ReverseWithdrawalsList />} /> */}
                    </>
                  )}
                </Routes>
              </DataLoad.Provider>
            </PlanPermission.Provider>
          </ChangePathContext.Provider>
        </TableColumnsContext.Provider>
      </UserProvider>
    </LastRouteProvider>
  );
};

export default App;
